<template>
  <div>
    <p class="text-center text-muted" v-html="message"></p>
  </div>
</template>

<script>

  const messages = {
    facebook_messenger: 'You will find here a list of Facebook Messenger users. Find out ' +
      '<a href="https://docs.amio.io/docs/facebook-messenger-entry-points" target="_blank"> how to collect your first contacts.</a>',
    viber: 'You will find here a list of Viber users. Find out ' +
      '<a href="https://docs.amio.io/docs/viber-entry-points" target="_blank"> how to collect your first contacts.</a>'
  }

  export default {
    store: {
      channel: 'administration.channelDetail.channel'
    },

    computed: {
      message() {
        return messages[this.channel.type]
      }
    }
  }
</script>
